module.exports = __webpack_public_path__ + "static/media/Barlow-Medium.788f9cc4.ttf";